export const DOWNLOAD_PACKING_SLIP = 'DOWNLOAD_PACKING_SLIP';
export const downloadPackingSlip = (fulfillmentPlanIds, hasPrintedPackingSlip, packingSlipTemplateId, override) => {
  return {
    type: DOWNLOAD_PACKING_SLIP,
    fulfillmentPlanIds,
    hasPrintedPackingSlip,
    packingSlipTemplateId,
    override,
  };
};

export const DIRECT_PRINT_PACKING_SLIP = 'DIRECT_PRINT_PACKING_SLIP';
export const directPrintPackingSlip = (fulfillmentPlanIds, hasPrintedPackingSlip, printSetting, packingSlipTemplateId, override) => {
  return {
    type: DIRECT_PRINT_PACKING_SLIP,
    fulfillmentPlanIds,
    hasPrintedPackingSlip,
    printSetting,
    packingSlipTemplateId,
    override,
  };
};

export const PRINT_PACKING_SLIP = 'PRINT_PACKING_SLIP';
export const printPackingSlip = (fulfillmentPlanIds, hasPrintedPackingSlip, override = false, autoPrint = false) => {
  return {
    type: PRINT_PACKING_SLIP,
    fulfillmentPlanIds,
    hasPrintedPackingSlip,
    override,
    autoPrint,
  };
};

export const DOWNLOAD_LABEL = 'DOWNLOAD_LABEL';
export const downloadLabel = (fulfillmentIds, hasPrintedLabel, override = false) => {
  return {
    type: DOWNLOAD_LABEL,
    fulfillmentIds,
    hasPrintedLabel,
    override,
  };
};

export const DIRECT_PRINT_LABEL = 'DIRECT_PRINT_LABEL';
export const directPrintLabel = (fulfillmentIds, hasPrintedLabel, printSetting, override = false) => {
  return {
    type: DIRECT_PRINT_LABEL,
    fulfillmentIds,
    hasPrintedLabel,
    printSetting,
    override,
  };
};

export const PRINT_LABEL = 'PRINT_LABEL';
export const printLabel = (
  fulfillmentPlanIds,
  fulfillmentIds,
  hasPrintedLabel,
  override = false,
  autoPrint = false,
  shouldNotLaunchPrintModal = false,
) => {
  return {
    type: PRINT_LABEL,
    fulfillmentPlanIds,
    fulfillmentIds,
    hasPrintedLabel,
    override,
    autoPrint,
    shouldNotLaunchPrintModal,
  };
};

export const PRINT_PICK_LIST = 'PRINT_PICK_LIST';
export const printPickList = (fulfillmentPlanIds, isUseCustomerDocType) => {
  return {
    type: PRINT_PICK_LIST,
    fulfillmentPlanIds,
    isUseCustomerDocType,
  };
};

export const PRINT_ORDER_SUMMARY = 'PRINT_ORDER_SUMMARY';
export const printOrderSummary = (fulfillmentPlanIds, shouldOpenPrintModal) => {
  return {
    type: PRINT_ORDER_SUMMARY,
    fulfillmentPlanIds,
    shouldOpenPrintModal,
  };
};

export const PRINT_ORDER_SUMMARY_FROM_SHIPMENTS_GRID = 'PRINT_ORDER_SUMMARY_FROM_SHIPMENTS_GRID';
export const printOrderSummaryFromShipmentsGrid = (fulfillmentPlanIds, shouldOpenPrintModal) => {
  return {
    type: PRINT_ORDER_SUMMARY_FROM_SHIPMENTS_GRID,
    fulfillmentPlanIds,
    shouldOpenPrintModal,
  };
};

export const PRINT_CUSTOMS_FORMS = 'PRINT_CUSTOMS_FORMS';
export const printCustomsForms = (fulfillmentPlanIds) => {
  return {
    type: PRINT_CUSTOMS_FORMS,
    fulfillmentPlanIds,
  };
};

export const PRINT_CUSTOMS_FORMS_FOR_ORDERS = 'PRINT_CUSTOMS_FORMS_FOR_ORDERS';
export const printCustomsFormsForOrders = (salesOrderIds) => {
  return {
    type: PRINT_CUSTOMS_FORMS_FOR_ORDERS,
    salesOrderIds,
  };
};

export const PRINT_END_OF_DAY_FORMS = 'PRINT_END_OF_DAY_FORMS';
export const printEndOfDayForms = (endOfDayScanFormIds) => {
  return {
    type: PRINT_END_OF_DAY_FORMS,
    endOfDayScanFormIds,
  };
};

export const PRINT_SHIPMENT_MANIFEST = 'PRINT_SHIPMENT_MANIFEST';
export const printShipmentManifest = (fulfillmentPlanIds) => {
  return {
    type: PRINT_SHIPMENT_MANIFEST,
    fulfillmentPlanIds,
  };
};

export const PRINT_MODAL_OPEN = 'PRINT_MODAL_OPEN';
export const openPrintModal = (pdfFilePath, documentType, fulfillmentPlanIds, fulfillmentIds, fulfillmentPlanSetIds) => {
  return {
    type: PRINT_MODAL_OPEN,
    pdfFilePath,
    documentType,
    fulfillmentPlanIds,
    fulfillmentIds,
    fulfillmentPlanSetIds,
  };
};

export const PRINT_MODAL_OPEN_END_OF_DAY_FORM = 'PRINT_MODAL_OPEN_END_OF_DAY_FORM';
export const openPrintModalForEndOfDayForm = (pdfFilePath, endOfDayScanFormIds) => {
  return {
    type: PRINT_MODAL_OPEN_END_OF_DAY_FORM,
    pdfFilePath,
    endOfDayScanFormIds,
  };
};

export const PRINT_LABEL_FROM_FULFILLMENT_PLAN = 'PRINT_LABEL_FROM_FULFILLMENT_PLAN';
export const printLabelFromFulfillmentPlan = ({
  fulfillmentPlanId,
  fulfillmentId,
  hasPrintedLabel = false,
  override = false,
  autoPrint = true,
}) => {
  return {
    type: PRINT_LABEL_FROM_FULFILLMENT_PLAN,
    hasPrintedLabel,
    override,
    autoPrint,
    fulfillmentPlanId,
    fulfillmentId,
  };
};

export const PRINT_MODAL_CLOSING = 'PRINT_MODAL_CLOSING';
export const closingPrintModal = () => {
  return {
    type: PRINT_MODAL_CLOSING,
  };
};

export const DOCUMENT_DOWNLOAD_STARTED = 'DOCUMENT_DOWNLOAD_STARTED';
export const documentDownloadStarted = (docType, docCount) => {
  return {
    type: DOCUMENT_DOWNLOAD_STARTED,
    docType,
    docCount,
  };
};

export const SET_PRINT_DESTINATION = 'SET_PRINT_DESTINATION';
export const setPrintDestination = (printDestination) => {
  return {
    type: SET_PRINT_DESTINATION,
    printDestination,
  };
};

export const SET_PRINT_FORMAT = 'SET_PRINT_FORMAT';
export const setPrintDocumentFormat = (printDocumentFormat) => {
  return {
    type: SET_PRINT_FORMAT,
    printDocumentFormat,
  };
};

export const SET_REMEMBER_PRINT_SETTINGS = 'SET_REMEMBER_PRINT_SETTINGS';
export const setRememberPrintSettings = (rememberPrintSettings) => {
  return {
    type: SET_REMEMBER_PRINT_SETTINGS,
    rememberPrintSettings,
  };
};

export const CHANGE_OUTPUT_TYPE = 'CHANGE_OUTPUT_TYPE';
export const changeOutputType = (outputType) => {
  return {
    type: CHANGE_OUTPUT_TYPE,
    outputType,
  };
};

export const MARK_LABEL_PRINTED = 'MARK_LABEL_PRINTED';
export const markLabelPrinted = (fulfillmentPlanIds, fulfillmentIds, isPrinted = true) => {
  return {
    type: MARK_LABEL_PRINTED,
    fulfillmentPlanIds,
    fulfillmentIds,
    isPrinted,
  };
};

export const MARK_LABEL_PRINTED_SUCCESS = 'MARK_LABEL_PRINTED_SUCCESS';
export const markLabelPrintedSuccess = (fulfillmentPlanIds, isPrinted) => {
  return {
    type: MARK_LABEL_PRINTED_SUCCESS,
    fulfillmentPlanIds,
    isPrinted,
  };
};

export const MARK_LABEL_PRINTED_FAILURE = 'MARK_LABEL_PRINTED_FAILURE';
export const markLabelPrintedFailure = (error) => {
  return {
    type: MARK_LABEL_PRINTED_FAILURE,
    error,
  };
};

export const MARK_PACKING_SLIP_PRINTED = 'MARK_PACKING_SLIP_PRINTED';
export const markPackingSlipPrinted = (fulfillmentPlanId, isPrinted) => {
  return {
    type: MARK_PACKING_SLIP_PRINTED,
    fulfillmentPlanId,
    isPrinted,
  };
};

export const MARK_PACKING_SLIP_PRINTED_SUCCESS = 'MARK_PACKING_SLIP_PRINTED_SUCCESS';
export const markPackingSlipPrintedSuccess = () => {
  return {
    type: MARK_PACKING_SLIP_PRINTED_SUCCESS,
  };
};

export const MARK_PACKING_SLIP_PRINTED_FAILURE = 'MARK_PACKING_SLIP_PRINTED_FAILURE';
export const markPackingSlipPrintedFailure = (error) => {
  return {
    type: MARK_PACKING_SLIP_PRINTED_FAILURE,
    error,
  };
};

export const MARK_PICK_LIST_PRINTED = 'MARK_PICK_LIST_PRINTED';
export const markPickListPrinted = (fulfillmentPlanId, isPrinted) => {
  return {
    type: MARK_PICK_LIST_PRINTED,
    fulfillmentPlanId,
    isPrinted,
  };
};

export const MARK_PICK_LIST_PRINTED_SUCCESS = 'MARK_PICK_LIST_PRINTED_SUCCESS';
export const markPickListPrintedSuccess = () => {
  return {
    type: MARK_PICK_LIST_PRINTED_SUCCESS,
  };
};

export const MARK_PICK_LIST_PRINTED_FAILURE = 'MARK_PICK_LIST_PRINTED_FAILURE';
export const markPickListPrintedFailure = (error) => {
  return {
    type: MARK_PICK_LIST_PRINTED_FAILURE,
    error,
  };
};

export const PRINT_RETURN_LABELS = 'PRINT_RETURN_LABELS';
export const printReturnLabels = (fulfillmentIds) => ({
  type: PRINT_RETURN_LABELS,
  fulfillmentIds,
});

export const MANUALLY_SET_DOC_COUNT = 'MANUALLY_SET_DOC_COUNT';
export const manuallySetPrintingDocCount = (docCount) => ({
  type: MANUALLY_SET_DOC_COUNT,
  docCount,
});

export const GENERATE_ORDER_SUMMARY = 'GENERATE_ORDER_SUMMARY';
export const generateOrderSummary = (fulfillmentPlanIds, shouldOpenPrintModal) => ({
  type: GENERATE_ORDER_SUMMARY,
  fulfillmentPlanIds,
  shouldOpenPrintModal,
});

export const PRINT_HOTKEYS_AND_BARCODE = 'PRINT_HOTKEYS_AND_BARCODE';
export const printHotkeysAndBarcode = () => {
  return {
    type: PRINT_HOTKEYS_AND_BARCODE,
  };
};

export const PRINT_PURCHASE_ORDER = 'PRINT_PURCHASE_ORDER';
export const printPurchaseOrder = (purchaseOrderId, printType) => {
  return {
    type: PRINT_PURCHASE_ORDER,
    purchaseOrderId,
    printType,
  };
};

export const PRINT_LOCATION_BARCODE = 'PRINT_LOCATION_BARCODE';
export const printLocationBarcode = (locationsIds, printType) => {
  return {
    type: PRINT_LOCATION_BARCODE,
    locationsIds,
    printType,
  };
};

export const PRINT_UOM_BARCODES = 'PRINT_UOM_BARCODES';
export const printUomBarcodes = (barcodes) => {
  return {
    type: PRINT_UOM_BARCODES,
    barcodes,
  };
};
